import React,{ useState} from 'react';
import { useSelector} from 'react-redux';
import { Divider, Loader, Modal, Button } from 'rsuite';
import * as actionsUser  from '../../../../app/actions/user';
import { NuInsInputTextLabel, NuInsSmsCodeLabel } from '../elements/inputFieldsLabel';
import {BackIcon, Vector} from '../svg/iconsSvg';
import {FrameIconFP} from '../svg/iconFrameSvg';
import { SecurityIcon } from "../svg/iconDashSvg";
import CounterButton from '../elements/CounterButton';

const ProfileChangeEmail = ({onBack, onForward, style}) => {

    const userDetails = useSelector(state => state.userDetails);

    const [loading, setLoading] = useState(false);

    const [newEmail, setNewEmail] = useState('');

    const [refNo, setRefNo] = useState(null);

    const [checkFields, setCheckFields] = useState({});

    const [enteredSmsCode, setEnteredSmsCode] = useState('');

    const [showModal, setShowModal] = useState({open: false, success: false, text: ''});

    const goBack = () => onBack(4);

    const focusFirstCodeField = () => {    
        const el = document.getElementById("sms-1");
        if (el) el.focus();
      };

    const onChangeHandler = (data) => {
        setNewEmail(data);
    }

    const onBlurHandler = (field) =>  {
        setCheckFields({...checkFields, [field]: true});
    }

    const emailValidation = (email) => {
        const re = /\S+@\S+\.\S+/;
        return re.test(email);
    }

    const checkForError = (field, type, allFields) =>  {
        
        switch (type) {
            case 'email':
                return (checkFields[field] || allFields) && (!newEmail || !emailValidation(newEmail));
            default:
                return false;
        }
    }

    const generateErrorMsg = (field, type) => {
        switch (type) {
            case 'email':
                if(!newEmail) return "Полето е задължително"
                if(newEmail && !emailValidation(newEmail)) return "Невалиден имeил адрес";
                break
            default:
                return "Полето е задължително";
        }
    }

    const submitChangeHandler = async () => {
        if(checkForError('email', 'email', true) || newEmail === userDetails?.email) return;

        setLoading(true);

        let res;

        try{
            res = await actionsUser.changeEmail(newEmail, userDetails?.email);
        } catch (error) {
            console.log(error);
        }

        if(res?.data && res?.data?.status === 0) {
            setRefNo(res?.data?.refNo);
            setTimeout(()=>focusFirstCodeField(), 100);
        }

        setLoading(false);

      //  console.log(res?.data);
    }

    //..................................................................................

    const closeModal = () => {
        if(showModal.success) {
            return onForward(3);
        }

        setShowModal({open: false, success: false, text: ''});
    }

    const generateSmsCode = () => {
        setEnteredSmsCode('');
        submitChangeHandler();
    }

    const onCodeEnteredHandle = (enteredCode) => {
        if(!enteredCode) return;

        setEnteredSmsCode(enteredCode);
    }

    const validateSmsCode = () => {
        return enteredSmsCode.length === 6;
    }

    const submitAuthorizeHandle = async () => {
        if(!validateSmsCode()) return;

        setLoading(true);

        let res;

        try{
            res = await actionsUser.authorizeChangeEmail(refNo, enteredSmsCode);
        } catch (error) {
            console.log(error);
        }

        if(res?.data && res?.data?.status === 0) {
            setShowModal({open: true, success: true, text: 'Успешно променен имеил'})
        } else if(res?.data && res?.data?.messageCode === "AUTH_CODE_INVALID" ) {
            setShowModal({open: true, success: false, text: 'Грешен sms код, моля генерирайте нов код'})
        }

        setLoading(false);

       // console.log(res?.data);

    }

    return (
        <div className="steps_container" style={style}>
            <div className="head">
                <div className="head-icon" style={{paddingLeft: '2rem'}} onClick={goBack}><BackIcon size={32}/></div>
                <h6 className="title" style={{marginRight: '48px'}}>Смяна на имеил</h6>
            </div>
            <Divider />
            {!refNo ? <>
        
                <div style={{textAlign: 'center', margin: '40px 0 60px 0'}}> <FrameIconFP size={90} /></div>
             
                <NuInsInputTextLabel    slice={50}                            
                                        placeholder={"Стар имеил"} 
                                        value={userDetails?.email}
                                        styles={{marginBottom: '20px'}}/>
                <NuInsInputTextLabel onChange={(data)=>onChangeHandler(data)} onBlur={()=>onBlurHandler('email')}
                                        slice={50}                            
                                        placeholder={"Нов имеил"} 
                                        value={newEmail}
                                        error={checkForError('email', 'email')} 
                                        errorMsg={generateErrorMsg('email', 'email')}
                                        styles={{marginBottom: '90px'}}/>  

                <button className="nuIns-btn nuIns-btn-mx nuIns-btn-main" type="submit" 
                        onClick={submitChangeHandler} >Потвърди</button>

            </>
            : <>            
                <div style={{textAlign: 'center', margin: '20px 0 40px 0' }}> <Vector  /></div>

                <h6 className="text-main">{userDetails?.mobTelephone}</h6>
                <div className="steps_container-checkbox" style={{justifyContent: 'center', marginBottom: '40px'}}>
                    <SecurityIcon />
                    <div>Изпратен е SMS код на този номер </div>
                </div>
           
                <CounterButton onSubmit={generateSmsCode} startWithCountdown={true}/>
             
                <p className="text-main" style={{ alignSelf: "start",paddingLeft: "2rem", fontWeight: '500', margin: '40px 0 8px 0'}} > Код от SMS </p>  
         
                <NuInsSmsCodeLabel onChange={onCodeEnteredHandle}/>

                <button className="nuIns-btn nuIns-btn-main" type="submit" style={{margin: '75px 0 40px'}}
                            disabled={!validateSmsCode()}
                            onClick={submitAuthorizeHandle} >Продължи</button>
            </>}

            {loading ? <Loader backdrop center size="lg" speed="slow" /> : null }

            {/* Modal */}
            <Modal size="xs" show={showModal.open} className="nuins-ok-modal" onHide={() => closeModal()}>
                <Modal.Body >
                    <p className="no-reg-data" >{showModal.text}</p>    
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => closeModal()} >OK</Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default ProfileChangeEmail;

